'use strict';
var TrackingProvider;
(function (TrackingProvider) {
    TrackingProvider["GA"] = "GA";
    TrackingProvider["GTM"] = "GTM"; // Google Tag MAnager
})(TrackingProvider || (TrackingProvider = {}));
export default TrackingProvider;
